<template>
	<div>
		<div class="searchBox" v-if="ifSearchText">
      <!-- /流水号/身份证/手机号/姓名 -->
			<el-input v-model="searchText" placeholder="请输入卡号" style="width: 400px;" clearable></el-input>
			<el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
		</div>
		<div class="table" v-if="statusShow">
			<template>
				<p>实体卡信息</p>
				<ul>
					<li>序列号：{{messageData.card.codeNo}}</li>
					<li>卡号：{{messageData.card.code}}</li>
					<li>激活有效期：{{setTime(messageData.holder.activeFrom)}} -- {{setTime(messageData.holder.activeTo)}}</li>
					<li>销售状态：{{messageData.sale.saleStatus == 1 ?'已售':'未售'}}</li>
					<!-- <li>激活日期：00000</li> -->
					<li>
						激活状态：{{messageData.holder.status == 1?'未激活':'已激活'}}
						<el-button v-if="messageData.holder.status == 1" type="primary" plain size="mini" @click='centerDialogVisible1=true'>去激活</el-button>
					</li>
				</ul>			
		
			</template>

			<template v-if="messageData.holder.status == 2">
				<p>保障人信息</p>
				<ul>
					<li>保障人姓名：{{messageData.sale.name}}</li>
					<li>保障人证件号：{{messageData.sale.nationalId}}</li>
					<li>保障人生日：{{setTime(messageData.sale.birthday)}}</li>
				</ul>
				<p>保障信息</p>
				<ul>
					<li>
						激活日期：{{setTime(messageData.holder.validFrom)}}
					</li>
					<li>
						保障凭证：
						<a v-if="messageData.sale.serviceCredential" target="_blank" class="blue" :href="messageData.sale.serviceCredential">查看凭证</a>
						<a v-else class="blue" >无</a>
					</li>
					<li>
						保险保单：
						<a v-if="messageData.sale.policyUrl" target="_blank" class="blue" :href="messageData.sale.policyUrl">查看保单</a>
						<a v-else class="blue" >无</a>
					</li>
				</ul>
        
			</template>
           	<!-- <a class="blue" style="float: right;margin-top: 50px;" @click="history()">查看历史保障人</a>		 -->
		</div>
		<div class="btn" v-if="statusShow">
			<el-button type="primary" style='margin-right: 200px;' @click='centerDialogVisible=true;' v-if="messageData.sale.saleStatus != 1">标记为已售</el-button>
			<!-- <el-button type="primary">查看订单详情</el-button> -->
		</div>
		<el-dialog title="为实体卡指定销售日期" :visible.sync="centerDialogVisible" width="500px" center>
			<span>销售时间</span>
			<el-date-picker v-model="validFrom" type="datetime" placeholder="选择日期"  :default-value='nowData' value-format="timestamp"></el-date-picker>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitSh()">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 弹窗添加保障 -->
		<el-dialog title="保障卡激活" :visible.sync="centerDialogVisible1" center @close="resetForm('numberValidateForm')">
      <div>
        <vue-qr class='fukuanBox'  :text="payImg" :logoSrc="imagePath" :size="500"></vue-qr>
      </div>
      
			<!-- <el-form label-position="right" :model="formInlineFz" label-width="120px" ref='numberValidateForm'>
				<el-form-item label="用户姓名:" prop="name" :rules="[
				  { required: true, message: '用户姓名不能为空'}
				]">
					<el-input v-model="formInlineFz.name" placeholder="请输入用户姓名"></el-input>
				</el-form-item>
				<el-form-item label="用户常住地:" prop="resident" :rules="[
				  { required: false, message: '常驻地不能为空'}
				]">
					<el-input v-model="formInlineFz.resident" placeholder="请输入用户常驻地"></el-input>
				</el-form-item>
				<el-form-item label="联系人手机号:" prop="mobileno" :rules="[
				  { required: false, message: '手机号不能为空'}
				]">
					<el-input v-model.number="formInlineFz.mobileno" placeholder="请输入联系人手机号"></el-input>
				</el-form-item>
				<el-form-item label="用户证件号:" prop="nationalId" :rules="[
				  { required: true, message: '用户证件号不能为空'}
				]">
					<el-input v-model="formInlineFz.nationalId" placeholder="请输入用户身份证或护照号" @blur="setIdFun" ref='focusBtn'></el-input>
				</el-form-item>
				<el-form-item label="出生日期:" prop="birthday" :rules="[
				  { required: birthdayBtn, message: '出生日期不能为空'}
				]">
					<el-date-picker v-model="formInlineFz.birthday" type="date" placeholder="选择日期"  :default-value='nowData' value-format="timestamp"></el-date-picker>
				</el-form-item>
				<el-form-item label="保障激活日期:" prop="validFrom" :rules="[
				  { required: true, message: '日期不能为空'}
				]">
					<el-date-picker v-model="formInlineFz.validFrom" type="datetime" placeholder="选择日期" :picker-options="pickerOptions" :default-value='nowData' value-format="timestamp"></el-date-picker>
				</el-form-item>
			</el-form> -->
      <!-- @click="submitForm('numberValidateForm') -->
			<el-button class='btn1' type="primary" @click='centerDialogVisible1=false'>关闭</el-button>
		</el-dialog>		
		
	</div>
</template>

<script>
import { codeQuery,activateCard,setSaleStatus } from '@/axios/api.js';
import common from '@/assets/common.js';
import vueQr from 'vue-qr'
export default {
	data() {
		return {
			imagePath: require("../../assets/img/logo2.png"),//中间logo的地址
			payImg:'',
			pickerOptions:{
				disabledDate(time) {
					return time.getTime() < Date.now();//如果没有后面的-8.64e7就是不可以选择今天的 
				 }
			},
			searchText: '',
			tableData: [],
			centerDialogVisible: false,
			centerDialogVisible1: false,
			validFrom:'',
			formInlineFz: {
				name: '',
				resident: '',
				mobileno: '',
				nationalId: '',
				validFrom: '',
				birthday:''
			},
			nowData:'',
			messageData:{
				card:{},
				holder:{},
				sale:{}
			},
			birthdayBtn:true,
			statusShow:false,
			ifSearchText:true
		};
	},
  components:{
		vueQr
	},
  // 3182200739932
	mounted() {
		var today = new Date();
		today.setHours(0);
		today.setMinutes(0);
		today.setSeconds(0);
		today.setMilliseconds(0);
		this.nowData =new Date(today.getTime() + 8.64e7)
		if(this.$route.query.code){
			this.ifSearchText=false;
			this.searchText=this.$route.query.code;
			this.getData()
		} 
	},
	methods: {
		history(){
			this.$router.push({
				path:'/shop/history'
			})	
		},
		setTime(str) {
			return common.time(str);
		},
		getData() {
			if(this.searchText == '') return this.$message.warning('请输入关键字！')
			var data = {
				// kw: this.searchText
                entiryCode:this.searchText
			};
			codeQuery(data)
				.then(res => {
					if(res.data.obj.product == undefined){
						this.statusShow=false;
						return this.$message.warning('未查到相关信息！')
					}
					this.messageData=res.data.obj;
					if(this.messageData.product.includeInsurance == 1){
						this.birthdayBtn=true
					}else{
						this.birthdayBtn=false
					}
					if(this.messageData.card != undefined){
						this.statusShow=true
					}else{
						this.statusShow=false
					}
					if(this.statusShow == true) {
						if(SEVERS == 'http://api.dajiuxing.com.cn/') {
						this.payImg = `http://api.dajiuxing.com.cn/djxh5/#/activationFamilf?type=2&code=${res.data.obj.card.code}`
						}else {
						this.payImg =`http://api.test.dajiuxing.com.cn/djxh5/#/activationFamilf?type=2&code=${res.data.obj.card.code}`
						}
					}
         
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if(!common.setIdFun(this.formInlineFz.nationalId,true)) {
						this.$message.warning('证件号不正确请重新输入！');
						this.$refs.focusBtn.focus();
						return
					}
					var list = {
						name: this.formInlineFz.name,
						resident: this.formInlineFz.resident,
						mobileno: this.formInlineFz.mobileno,
						nationalId: this.formInlineFz.nationalId,
						birthday:this.formInlineFz.birthday,
						validFrom:this.formInlineFz.validFrom
					}
					if(list.birthday == ''){
						delete list.birthday
					}
					var data={
						billdetail:JSON.stringify(list),
						code:this.messageData.card.code
					}
					activateCard(data)
					.then( res => {
						console.log(res)
						if(res.data.code == 0){
							this.$message({
								type:'success',
								message:'激活成功'
							})
							this.centerDialogVisible1=false;
							this.getData()
						}else{
							this.$message.warning(res.data.msg)
						}
					})
					.catch(err => {
						console.log(err)
					})
					
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		setIdFun(){
			var reg=/^[a-zA-Z].*/;
			var birthday='',str1='',str2='',str3='';
			var birthdayStr='';
			this.readonlyBtn=false;
			if(reg.test(this.formInlineFz.nationalId)){
				if(this.formInlineFz.nationalId.length > 18){
					return this.$message.error('护照格式不正确，请重新输入！')
				}
			}else{
				if(this.formInlineFz.nationalId.length == 18 || this.formInlineFz.nationalId.length == 15){
					if(this.formInlineFz.nationalId.length == 18){
						birthday=this.formInlineFz.nationalId.substring(6,14);
						str1=birthday.substring(0,4);
						str2=birthday.substring(4,6);
						str3=birthday.substring(6,8);
						if(str2>12){
							return this.$message.error('身份证号码不正确，请重新输入！')
						}
						if(str3>31){
							return this.$message.error('身份证号码不正确，请重新输入！')
						}
						birthdayStr=(new Date(`${str1}-${str2}-${str3}`)).getTime();
					}else{
						birthday=this.formInlineFz.nationalId.substring(6,12);
						str1=birthday.substring(0,2);							
						str2=birthday.substring(2,4);
						str3=birthday.substring(4,6);
						if(str2>12){
							return this.$message.error('身份证号码不正确，请重新输入！')
						}
						if(str3>31){
							return this.$message.error('身份证号码不正确，请重新输入！')
						}							
						birthdayStr=(new Date(`19${str1}-${str2}-${str3}`)).getTime();
					}
					this.formInlineFz.birthday=birthdayStr
					this.readonlyBtn=true
				}else{
					this.readonlyBtn=false;
					return this.$message.error('身份证号码不正确，请重新输入！')
				}
			}				
		},
		submitSh(){
			if(this.validFrom == 0) return this.$message.error('请指定销售时间！')
			var data={
				saleDate:this.validFrom,
				code:this.messageData.card.code
			}
			setSaleStatus(data)
			.then(res => {
				console.log(res)
				if(res.data.code == 0){
					this.$message({
						type:'success',
						message:'标记成功'
					})
					this.centerDialogVisible=false;
					this.getData()
				}
			})
			.catch(err => {
				console.log(err)
			})
		}
	}
};
</script>

<style scoped>
.fukuanBox {
  text-align: center;
}
.table {
	margin-top: 20px;
	margin-left: 100px;
	height: calc(100vh - 250px);
}
.searchBox {
	text-align: center;
}
.table ul {
	overflow: hidden;
	margin-left: 20px;
}
.table p {
	margin-top: 30px;
}
.table ul li {
	float: left;
	width: 33%;
	margin-top: 10px;
	line-height: 30px;
	font-size: 14px;
	color: #666;
}
.btn{text-align: center;}
.btn1{display: block;margin: 0 auto;}
</style>



// WEBPACK FOOTER //
// src/views/shop/activation.vue